import * as api from "../clients/slashid-api"
import * as domain from "../domain/index"

import { type SlashID } from "."
import { BaseUser } from "./user.base"
import { BrowserUser } from "./user.browser"

export class AnonymousUser extends BaseUser {
    private _slashid: SlashID

    /**
     * Reconstruct an anonymous user from its token value. Call the `id` method to authenticate the user.
     * If this results with registering a new user, the underlying user ID will be the same as the originating anonymous user.
     *
     * Instances can only be constructed in a browser environment due to dependency on {@link SlashID}.
     *
     * @param token A user {@link token} value.
     * @param slashid SlashID instance
     *
     * @throws `TypeError` the given token cannot be decoded.
     */
    constructor(token: domain.UserTokenText | domain.TokenContainerText, slashid: SlashID) {
        // both the options and SlashID instances have the same fields (baseURL, sdkURL, oid)
        super(token, slashid)

        if (this.decoded.person_type !== "anonymous") {
            throw new Error("Token must have person_type 'anonymous'")
        }

        this._slashid = slashid
    }

    /**
     *  Authenticates the [AnonymousUser], on success the user is now a permanently registered user.
     *
     *  @returns `Promise<BrowserUser>`
     */
    public async id(handle: api.PersonHandle, authenticationFactor: domain.Factor): Promise<BrowserUser> {
        return this._slashid._id(this.decoded.oid!, handle, authenticationFactor, this.token)
    }
}
